export const domainsToSelect = (domains) => {
  if (!domains) return [];
  return domains.map((d) => ({
    value: d.domain_id,
    label: d.domain_url,
  }));
};
